import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { Store } from './core/store/store';
import { HeaderComponent } from './modules/layout/components/header/header.component';
import { SidebarComponent } from './modules/layout/components/sidebar/sidebar.component';
import { DashboardLayoutComponent } from './modules/layout/container/dashboard-layout/dashboard-layout.component';
import { HomeLayoutComponent } from './modules/layout/container/home-layout/home-layout.component';
import { NotesBookmarksModule } from './modules/notes-bookmarks/notes-bookmarks.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LeaderboardModule } from './modules/leaderboard/leaderboard.module';
import { HttpClientService } from './core/http/http-client';
import { ToastrModule } from 'ngx-toastr';
// import { QuestionVideoFeedbackComponent } from './shared/components/question-video-feedback/question-video-feedback.component';
import { SharedModule } from './shared/shared.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { HttpErrorInterceptor } from './core/interceptor/http-error.interceptor';
import { ReportsModule } from './modules/reports/reports.module';
import { PartnerDashboardLayoutComponent } from './modules/layout/container/partner-dashboard-layout/partner-dashboard-layout.component';
import { NewHeaderComponent } from './modules/layout/components/new-header/new-header.component';
import { NewSidebarComponent } from './modules/layout/components/new-sidebar/new-sidebar.component';
import {PartnerDashboardModule}  from './modules/partner-dashboard/partner-dashboard.module';
import { ProgressbarModule,ProgressbarConfig } from 'ngx-bootstrap/progressbar';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { PartnerHttpClientService } from './core/http/partner-http-client';
import { LoadingComponent } from './modules/partner-dashboard/common/loader/loading';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    DashboardLayoutComponent,
    HomeLayoutComponent,
    PartnerDashboardLayoutComponent,
    NewHeaderComponent,
    NewSidebarComponent,
    LoadingComponent
    
    // QuestionVideoFeedbackComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NotesBookmarksModule,
    NgbModule,
    LeaderboardModule,
    ReportsModule,
    PartnerDashboardModule,
    ToastrModule.forRoot({
      preventDuplicates: true
    }),
    
    SharedModule,
    BrowserAnimationsModule,
    NgxIntlTelInputModule,    
    ProgressbarModule.forRoot(),
    NgCircleProgressModule.forRoot()
  ],
  providers: [
    HttpClientService,
    PartnerHttpClientService,
    Store,
    { provide : HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi : true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },    
    ProgressbarConfig
  ],
  // schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  bootstrap: [AppComponent]
})
export class AppModule { }
